import apiEndPoints from "../../utils/apiEndPoints";
import { apiCall } from "../../utils/httpClient";

const getAllProperty = async (params) => {
  const data = await apiCall("post", apiEndPoints.PROPERTYLIST, params);
  return data;
};
const getAgentProperty = async (params) => {
  const data = await apiCall("post", apiEndPoints.PROPERTYLISTBYAGENT, params);
  return data;
};
const propertyCheck = async (params) => {
  const data = await apiCall("post", apiEndPoints.PROPERTYCHECK, params);
  return data;
};
const addProperty = async (params) => {
  const data = await apiCall("post", apiEndPoints.ADDPROPERTY, params, {
    "Content-Type": "application/x-www-form-urlencoded",
  });
  return data;
};
const editProperty = async (params) => {
  const data = await apiCall("post", apiEndPoints.EDITPROPERTY, params, {
    "Content-Type": "application/x-www-form-urlencoded",
  });
  return data;
};
const getPropertyDetail = async (params) => {
  const data = await apiCall("post", apiEndPoints.GETPROPERTYDETAIL, params);
  return data;
};
const getPropertyFilterDetail = async (params) => {
  const data = await apiCall(
    "post",
    apiEndPoints.GETPROPERTYFILTERDETAIL,
    params
  );
  return data;
};
const propertyStatusUpdate = async (params) => {
  const data = await apiCall("post", apiEndPoints.PROPERTYSTATUSUPDATE, params);
  return data;
};

const propertyGreMobileOtpUpdate = async (params) => {
  const data = await apiCall(
    "post",
    apiEndPoints.PROPERTY_GRE_MOBILE_OTP_UPDATE,
    params,
  );
  return data;
};

// Multipart GRE banner upload (FormData must not be spread into a plain object).
const propertyGreBannerUpdate = async (formData) => {
  const data = await apiCall(
    "post",
    apiEndPoints.PROPERTY_GRE_BANNER_UPDATE,
    formData,
  );
  return data;
};

// Fetches GRE banner image as blob for preview and GreBannerImage display.
// 204 = property has no GRE banner (expected); component should hide the banner.
const getGreBannerImageBlob = async (params) => {
  const data = await apiCall(
    "post",
    apiEndPoints.GET_GRE_BANNER_IMAGE,
    params,
    {
      "Content-Type": "application/json",
    },
    {
      responseType: "blob",
      validateStatus: (status) => status === 200 || status === 204,
    },
  );
  if (data?.status === 204) {
    return { ...data, data: null, noBanner: true };
  }
  return data;
};

// Clears gre_banner on the property (backend also removes the S3 object).
const propertyGreBannerRemove = async (params) => {
  const data = await apiCall(
    "post",
    apiEndPoints.PROPERTY_GRE_BANNER_REMOVE,
    params,
  );
  return data;
};

const getConfigurationPropList = async (params) => {
  const data = await apiCall(
    "post",
    apiEndPoints.PROPERTYCONFIGURATIONLIST,
    params
  );
  return data;
};
const propertyDocumentDelete = async (params) => {
  const data = await apiCall(
    "post",
    apiEndPoints.PROPERTYDOCUMENTDELETE,
    params
  );
  return data;
};

const syncAllProjects = async (params) => {
  const data = await apiCall("post", apiEndPoints.SYNCALLPROJECT, params);
  return data;
};

const getPropertyBasedSM = async (params) => {
  const data = await apiCall("post", apiEndPoints.GET_PROPERTY_BASED_SM, params);
  return data;
};

// JUSTO-64: GRE allocation – fetch CMs + SCM (dual role) for property; used by AllocateSM modal.
const getPropertyBasedCM = async (params) => {
  const data = await apiCall("post", apiEndPoints.GET_PROPERTY_BASED_CM, params);
  return data;
};

const propertyService = {
  getAllProperty,
  getAgentProperty,
  propertyCheck,
  addProperty,
  editProperty,
  getPropertyDetail,
  getPropertyFilterDetail,
  propertyStatusUpdate,
  propertyGreMobileOtpUpdate,
  propertyGreBannerUpdate,
  propertyGreBannerRemove,
  getGreBannerImageBlob,
  getConfigurationPropList,
  propertyDocumentDelete,
  syncAllProjects,
  getPropertyBasedSM,
  getPropertyBasedCM,
};

export default propertyService;
